/**
 * Type → icon mapping for notification rows. Shared by the bell popover and
 * the /inbox page so the two surfaces read as one system.
 */

import {
  AtSign,
  Bell,
  Briefcase,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarPlus,
  CalendarX2,
  Compass,
  Heart,
  MessageSquare,
  MessagesSquare,
  Newspaper,
  Reply,
  Share2,
  Users,
  Video,
} from 'lucide-react';

export function NotificationIcon({ type }: { type: string }) {
  switch (type) {
    case 'community.message': return <MessageSquare className="w-4 h-4 text-info" />;
    case 'community.mention': return <AtSign className="w-4 h-4 text-primary" />;
    case 'community.post_mention': return <AtSign className="w-4 h-4 text-primary" />;
    case 'community.comment_mention': return <AtSign className="w-4 h-4 text-primary" />;
    case 'community.reply': return <MessageSquare className="w-4 h-4 text-success" />;
    case 'community.reaction': return <Heart className="w-4 h-4 text-danger" />;
    case 'community.member_joined': return <Users className="w-4 h-4 text-info" />;
    case 'community.lead_received': return <Briefcase className="w-4 h-4 text-warning" />;
    case 'community.event_reminder': return <Calendar className="w-4 h-4 text-primary" />;
    case 'community.event_created': return <CalendarPlus className="w-4 h-4 text-primary" />;
    case 'community.event_updated': return <CalendarClock className="w-4 h-4 text-warning" />;
    case 'community.event_cancelled': return <CalendarX2 className="w-4 h-4 text-danger" />;
    case 'community.event_recording_ready': return <Video className="w-4 h-4 text-primary" />;
    // Host-side "someone answered your invitation" (86d45mxh0). Information
    // only, so it is deliberately absent from the inbox Actions filter.
    case 'community.event_rsvp': return <CalendarCheck className="w-4 h-4 text-success" />;
    case 'community.post_shared': return <Share2 className="w-4 h-4 text-info" />;
    case 'community.channel_post': return <Newspaper className="w-4 h-4 text-info" />;
    // MessagesSquare (stacked), not MessageSquare: a comment on your post must
    // be distinguishable from a plain chat message in a mixed list.
    case 'community.post_comment': return <MessagesSquare className="w-4 h-4 text-info" />;
    case 'community.comment_reply': return <Reply className="w-4 h-4 text-success" />;
    case 'community.post_reaction': return <Heart className="w-4 h-4 text-danger" />;
    // The morning move (hermes T8, migration 614): the one coaching type in the bell.
    case 'coaching.move': return <Compass className="w-4 h-4 text-primary" />;
    default: return <Bell className="w-4 h-4 text-muted-foreground" />;
  }
}
